import { createFileRoute } from '@tanstack/react-router'
import Datasets from '../../../../../containers/Datasets'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/datasets'
)({
  component: Datasets
})
